function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.44 17.76c.2-1.8.3-4.07.5-4.76-1.4 1.14-2.1 3.34-2.23 5.1-.6-1.76-1.76-3.28-2.7-3.48.36.77.9 4.36 2.77 5.37h.4v-.06c.3-.03.46 0 .67.03h.8c.93-.38 2.54-5.1 3.02-6.06-.96.46-2.36 1.96-3.18 3.83zm10-9c.2-1.8.3-4.07.5-4.76-1.4 1.14-2.1 3.34-2.23 5.1-.6-1.76-1.76-3.28-2.7-3.48.36.77.9 4.36 2.77 5.37h.4v-.06c.3-.03.46 0 .67.03h.8c.93-.38 2.54-5.1 3.02-6.06-.96.46-2.36 1.96-3.18 3.83zm.5 6.34c-.17-.63-.75-1.1-1.44-1.1-.7 0-1.27.47-1.45 1.1-.17-.06-.35-.1-.55-.1-.83 0-1.5.67-1.5 1.5 0 .2.04.4.1.57-.63.2-1.1.76-1.1 1.43 0 .8.66 1.45 1.5 1.5h6c.84-.05 1.5-.7 1.5-1.5 0-.67-.47-1.24-1.1-1.43.06-.18.1-.37.1-.57 0-.83-.67-1.5-1.5-1.5-.2 0-.38.04-.55.1zm-9-9C8.78 5.48 8.2 5 7.5 5s-1.27.47-1.45 1.1C5.88 6.04 5.7 6 5.5 6 4.67 6 4 6.67 4 7.5c0 .2.04.4.1.57-.63.2-1.1.76-1.1 1.43 0 .8.66 1.45 1.5 1.5h6c.84-.05 1.5-.7 1.5-1.5 0-.67-.47-1.24-1.1-1.43.06-.18.1-.37.1-.57 0-.83-.67-1.5-1.5-1.5-.2 0-.38.04-.55.1z",
  fill: "currentColor"
});

var SvgLocationFell = function SvgLocationFell(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationFell;